"use client";

import type { QuoteFontSchema } from "@/@sdk/brands/brand-model";
import { SchemaToggle } from "./schema-toggle";

export function FontSchemaPicker({
  value,
  onChange,
}: {
  value: QuoteFontSchema;
  onChange: (value: QuoteFontSchema) => void;
}) {
  return (
    <SchemaToggle
      value={value}
      onChange={onChange}
      options={[
        { value: "SINGLE_FONT", label: "Single Font" },
        { value: "DUAL_FONT", label: "Dual Font" },
      ]}
    />
  );
}
